import {Injectable} from "@angular/core";
import {ICONS_PATH} from "../../../config/path";

@Injectable({providedIn: 'root'})
export class IconRegistryService {
  getExpanderIcon(expanded: boolean): string {
    return `${ICONS_PATH}images/table-icons/expander-${expanded ? 'on' : 'off'}_2x.png`;
  }
}
